export const NEW_LISTING = 'NEWLISTING';
export const OTHER_LISTING = 'OTHERS';
